import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import { ApiBaseService } from "./api-base.service";

@Injectable({
  providedIn: "root"
})
export class PrintDefinitionsService extends ApiBaseService {

  get baseUrl2() {
    return `${this.configService.config.directUrl}/api/printdefinition`;
  }

  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId }) };
  }

  getByPrintTypeMethod(method: string, ClientIPAddress: string = null, OperatorPanelToken: string = null, Client: string = null): Observable<any[]> {

    const theURL = `${this.baseUrl2}/getbyprinttypemethod?method=${method}`;
    let httpOptions = this.httpOptions;
    if (ClientIPAddress != null && ClientIPAddress.length > 0
      || OperatorPanelToken != null && OperatorPanelToken.length > 0
      || Client != null && Client.length > 0) {
      
      const headders = httpOptions.headers.set("ClientIPAddress", ClientIPAddress)
        .set("OperatorPanelToken", OperatorPanelToken)
        .set("Client", Client)
        .set("SessionId", this.userService.sessionId);
      httpOptions = { headers: headders };
    }
    return this.http.get<any[]>(theURL, httpOptions)
      .pipe(catchError(this.handleError<any[]>("Failed to get print definitions", [])));
  }

  addUserDefinedPrinter(printDefinitionId: number, printerId: number, employeeId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl2}/AddUserDefinedPrinter?printDefinitionId=${printDefinitionId}&printerId=${printerId}&employeeId=${employeeId}`, this.httpOptions)
      .pipe(catchError(this.handleError<any>("Failed to add user defined printer", null)));
  }
  removeUserDefinedPrinter(printDefinitionId: number, employeeId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl2}/RemoveUserDefinedPrinter?printDefinitionId=${printDefinitionId}&employeeId=${employeeId}`, this.httpOptions)
      .pipe(catchError(this.handleError<any>("Failed to change printer", null)));
  }

}
